import React from "react";
import get from "lodash/get";
import Slider from "react-slick";
import { ImageFallback } from "./../basic/image-fallback.js";
import { LazyLoadImages, wrapCollectionLayout, Link, ResponsiveImage } from "@quintype/components";
import { CollectionName, generateSectionPageRoutesDupe } from "../basic/collection-name";
import { getNumberOfCollectionToShow, getCarousel } from "../../utils";
import PropTypes from "prop-types";

import "./slider-collection-of-collections.module.css";

const CollectionCard = ({ collection, associatedMetadata, aspectRatio = [4, 3], route }) => {
  const coverImage = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");

  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], {});

  function showDefaultImage() {
    if (!coverImage) {
      return <ImageFallback styleName="aspect-ratio" />;
    }

    return (
      <figure styleName="aspect-ratio">
        <LazyLoadImages margin={"0px"}>
          <ResponsiveImage
            slug={coverImage}
            metadata={coverImageMetaData}
            alt={collection.name}
            aspectRatio={[4, 3]}
            defaultWidth={480}
            widths={[250, 480, 640]}
            sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 25vw"
            imgParams={{ auto: ["format", "compress"] }}
          />
        </LazyLoadImages>
      </figure>
    );
  }
  return (
    <div className="collection-card ">
      <Link href={route["sectionPath"] ? route["sectionPath"] : `/collection/${collection.slug}`}>
        <div styleName="collection-card-image" data-testid="collection-card-image">
          {showDefaultImage()}
        </div>
        <div styleName="collection-card-content">
          <h3 styleName="collection-card-headline" data-testid="collection-card-headline">
            {collection.name}
          </h3>
        </div>
      </Link>
    </div>
  );
};

CollectionCard.propTypes = {
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  aspectRatio: PropTypes.array,
  route: PropTypes.object,
};

function getRoute(config, item) {
  if (get(item, ["metadata", "section"])) {
    const [firstRoute, ...remainingRoutes] = generateSectionPageRoutesDupe(config, {}, item) || [];
    return firstRoute;
  }
  return {
    sectionPath: `/collection/${item.slug}`
  };
}

function SliderCollectionOfCollectionsBase(props) {
  const collections = get(props, ["collection", "items"], []).filter(item => item.type === "collection");
  const { collection: collection = true, metadata: associatedMetadata } = props;

  const {
    show_collection_title: collectionName = true,
    slider_type_dots: sliderTypeDots = false,
    slider_type_dashes: sliderTypeDashes = false,
    show_arrows: showArrows = true,
    set_scroll_speed: setScrollSpeed = 500,
    enable_auto_play: enableAutoPlay = true,
    numberOfColletionsToShow: numberOfColletionsToShow = 6,
    number_of_slides_to_scroll: numberOfSlidesToScroll = 1,
    number_of_slides_to_show: numberOfSlidesToShow = 4
  } = associatedMetadata;

  const settings = {
    dots: sliderTypeDots || sliderTypeDashes,
    infinite: true,
    lazyLoad: true,
    onLazyLoad: () => {},
    speed: setScrollSpeed,
    slidesToShow: parseInt(numberOfSlidesToShow),
    slidesToScroll: parseInt(numberOfSlidesToScroll),
    autoplay: enableAutoPlay,
    arrows: showArrows,
    dotsClass: sliderTypeDashes ? "dashpaging" : "slick-dots",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const Slide = (
    <div styleName="render-slider-wrapper">
      {collections.slice(0, 4).map(item => (
        <CollectionCard
          collection={item}
          aspectRatio={[4, 3]}
          associatedMetadata={associatedMetadata}
          key={item.id}
          route={getRoute(props.config, item)}
        />
      ))}
    </div>
  );
  const SliderWrapper = (
    <Slider {...settings} styleName="slider-collection-of-collections">
      {collections
        .slice(0, getNumberOfCollectionToShow(associatedMetadata["number_of_collections_to_show"]))
        .map(item => (
          <CollectionCard
            collection={item}
            aspectRatio={[4, 3]}
            associatedMetadata={associatedMetadata}
            key={item.id}
            route={getRoute(props.config, item)}
          />
        ))}
    </Slider>
  );
  return (
    <div className="wrapper">
      <div data-testid="slider-collection-of-collection">
        {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
        {getCarousel(SliderWrapper, Slide)}
      </div>
    </div>
  );
}

export const SliderCollectionOfCollections = wrapCollectionLayout(SliderCollectionOfCollectionsBase);
